import type { JSX } from 'react';
import { BOARD_VIEWS, viewWindow, type BoardView } from '../core/index.ts';

const NAMES: Readonly<Record<BoardView, string>> = {
  full: 'Whole pool',
  left: 'Left half',
  right: 'Right half',
};

interface ViewPickerProps {
  readonly view: BoardView;
  readonly onChange: (view: BoardView) => void;
}

/**
 * Three tiny pools, each with the stretch it shows filled in. It lives in the
 * top bar, off the canvas, so it never covers the field in any view and is
 * never part of a recording, which captures only the canvas.
 */
export function ViewPicker({ view, onChange }: ViewPickerProps): JSX.Element {
  return (
    <div className="view-picker" role="radiogroup" aria-label="Board view" data-tutorial="views">
      {BOARD_VIEWS.map((option) => {
        const { from, to } = viewWindow(option);
        const active = option === view;
        return (
          <button
            key={option}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={NAMES[option]}
            title={`${NAMES[option]} (H)`}
            className={`view-picker__option ${active ? 'view-picker__option--active' : ''}`}
            onClick={() => onChange(option)}
          >
            <svg viewBox="0 0 25 20" width="25" height="20" aria-hidden="true">
              <rect className="view-picker__shown" x={from * 25} y={0} width={(to - from) * 25} height={20} />
              <rect className="view-picker__pool" x={0.5} y={0.5} width={24} height={19} />
              <line className="view-picker__half" x1={12.5} y1={0.5} x2={12.5} y2={19.5} />
            </svg>
          </button>
        );
      })}
    </div>
  );
}
